/* eslint-disable no-console */
import { API } from 'aws-amplify';
import { Department, DepartmentsResponse } from './types';

// API endpoint name as configured in Amplify
const API_NAME = 'revisedResources';

/**
 * Get all departments for a specific company
 * @param companyId - Company identifier
 * @returns List of departments
 */
export const getDepartments = async (
  companyId: string
): Promise<Department[]> => {
  if (!companyId) {
    console.error('Company ID is required for getDepartments');
    throw new Error('Company ID is required');
  }

  try {
    const response = await API.get(
      API_NAME,
      `/departments/company/${companyId}`,
      {}
    ) as DepartmentsResponse;
    
    // If the API call was successful and we got data
    if (response?.success && response?.data) {
      return response.data;
    }
    
    // If the response format is unexpected or API returned an error
    console.warn('Unexpected response format from getDepartments:', response);
    return [];
  } catch (error) {
    console.error('Error getting departments:', error);
    throw error;
  }
};

/**
 * Get a specific department by ID
 * @param departmentId - Department identifier
 * @returns The department data
 */
export const getDepartmentById = async (
  departmentId: string
): Promise<Department> => {
  if (!departmentId) {
    console.error('Department ID is required for getDepartmentById');
    throw new Error('Department ID is required');
  }

  try {
    const response = await API.get(
      API_NAME,
      `/departments/${departmentId}`,
      {}
    ) as DepartmentsResponse;
    
    // If the API call was successful and we got data
    if (response?.success && response?.data && Array.isArray(response.data) && response.data.length > 0) {
      return response.data[0];
    }
    
    // If the response format is unexpected or API returned an error
    console.warn('Unexpected response format from getDepartmentById:', response);
    throw new Error('Failed to get department');
  } catch (error) {
    console.error('Error getting department by ID:', error);
    throw error;
  }
}; 